
export const
	TRANS_TIME = 600,
	MIN_DOT =  0,
	MAX_DOT = 6;
